import { useEffect, useState } from "react";
import { makeStyles, withStyles, InputBase } from "@material-ui/core";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useStylesApp } from "hooks/useStyles";
import { format } from "date-fns";
import bigDecimal from "js-big-decimal";
//Notificacion errores https://iamhosseindhv.com/notistack/demos#variants
import { useSnackbar } from "notistack";
import uuid from "react-uuid";
import checkInputs from "utils/checkInputs";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    margin: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1%",
    borderStyle: "solid",
    borderBottomWidth: "5px",
    borderRadius: "4px",
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divSelect: {
    width: "100%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
    marginBottom: "1%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  haedClient: {
    backgroundColor: palette.primary.light,
    width: "10%",
    marginBottom: "2%",
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1%",
    borderStyle: "solid",
    borderBottomWidth: "5px",
    borderRadius: "4px",
  },
}));

export default function useMultipleFiscalReference(
  documentosFiscales,
  setDocumentosFiscales,
  viewPago,
  setViewPago,
  iDoc
) {
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobal = useStylesGlobal();
  const [open, setOpen] = useState(false);
  const [isData, setIsData] = useState("DE");
  const [cufe, setCufe] = useState("");
  const [rucEmisor, setRucEmisor] = useState({
    ruc: "",
    tipoRuc: "",
    dv: "",
  });
  const { enqueueSnackbar } = useSnackbar();
  const [documentoFiscal, setDocumentoFiscal] = useState({
    id: uuid(),
    rucEmisor: {},
    nombreEmisor: "",
    fechaDocumento: "",
    cufeReferenciada: "",
    nroFacturaPapel: "",
    nroFacturaImpresora: "",
  });

  const [empty, setEmty] = useState({
    tipoRuc: true,
    ruc: true,
    dv: true,
    nombreEmisor: true,
    fechaDocumento: true,
    cufeReferenciada: true,
    nroFacturaPapel: true,
    nroFacturaImpresora: true,
  });

  useEffect(() => {
    setDocumentoFiscal({ ...documentoFiscal, rucEmisor: rucEmisor });
  }, [rucEmisor]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    cleanPago();
    setOpen(false);
  };

  const handleAddDocumentFiscal = () => {
    const errors = validationInputs();
    setEmty(errors);
    let isValid = Object.entries(errors).length > 0;
    if (!isValid) {
      if (documentosFiscales.length > 0) {
        documentoFiscal.fechaDocumento = format(
          new Date(documentoFiscal.fechaDocumento),
          "yyyy-MM-dd'T'HH:mm:ssXXX"
        );
        setDocumentosFiscales([...documentosFiscales, documentoFiscal]);
      } else {
        documentoFiscal.fechaDocumento = format(
          new Date(documentoFiscal.fechaDocumento),
          "yyyy-MM-dd'T'HH:mm:ssXXX"
        );
        setDocumentosFiscales([documentoFiscal]);
      }
      if (viewPago === 1) {
        setViewPago(2);
      } else {
        setViewPago(1);
      }
      handleClose();
      enqueueSnackbar(`Información de documento fiscal agregado`, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        autoHideDuration: 4000,
      });
    }
  };

  const handleChangeRuc = (event) => {
    setRucEmisor({
      ...rucEmisor,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeUniversal = (event) => {
    setDocumentoFiscal({
      ...documentoFiscal,
      [event.target.name]: event.target.value,
    });
  };

  const cleanPago = () => {
    setDocumentoFiscal({
      id: uuid(),
      rucEmisor: {},
      nombreEmisor: "",
      fechaDocumento: "",
      cufeReferenciada: "",
      nroFacturaPapel: "",
      nroFacturaImpresora: "",
    });
    setRucEmisor({
      tipoRuc: "",
      ruc: "",
      dv: "",
    });
    setEmty({
      tipoRuc: null,
      ruc: true,
      dv: true,
      nombreEmisor: true,
      fechaDocumento: true,
      cufeReferenciada: true,
      nroFacturaPapel: true,
      nroFacturaImpresora: true,
    });
    setCufe("");
    setIsData("DE");
  };

  const validationInputs = () => {
    let errors = {};

    if (!checkInputs.notNull(rucEmisor.ruc)) {
      errors.ruc =
        "Ingrese el RUC contribuyente del emisor del documento fiscal referenciado.";
    } else if (!checkInputs.isAlphanumeric(rucEmisor.ruc)) {
      errors.ruc = "Ingrese solo caracteres alfanuméricos.";
    } else if (
      checkInputs.countLenth(rucEmisor.ruc) < 5 ||
      checkInputs.countLenth(rucEmisor.ruc) > 20
    ) {
      errors.ruc = "Ingrese solo entre 5 y 20 caracteres.";
    }

    if (!checkInputs.notNull(rucEmisor.dv)) {
      errors.dv =
        "Ingrese el DV contribuyente del emisor documento fiscal referenciado.";
    } else if (!checkInputs.isNumeric(rucEmisor.dv)) {
      errors.dv = "Ingrese solo números.";
    } else if (checkInputs.countLenth(rucEmisor.dv) !== 2) {
      errors.dv = "Ingrese solo 2 dígitos.";
    }

    if (!checkInputs.notNull(rucEmisor.tipoRuc)) {
      errors.tipoRuc =
        "Ingrese el tipo contribuyente del emisor documento fiscal referenciado.";
    }

    if (!checkInputs.notNull(documentoFiscal.nombreEmisor)) {
      errors.nombreEmisor =
        "Ingrese el nombre  del emisor documento fiscal referenciado.";
    } else if (!checkInputs.isAlphanumeric(documentoFiscal.nombreEmisor)) {
      errors.nombreEmisor = "Ingrese solo caracteres alfanuméricos.";
    } else if (
      checkInputs.countLenth(documentoFiscal.nombreEmisor) < 2 ||
      checkInputs.countLenth(documentoFiscal.nombreEmisor) > 100
    ) {
      errors.ruc = "Ingrese solo entre 2 y 100 caracteres.";
    }

    if (!checkInputs.notNull(documentoFiscal.fechaDocumento)) {
      errors.fechaDocumento =
        "Ingrese la fecha del documento fiscal referenciado.";
    }

    if (checkInputs.notNull(documentoFiscal.cufeReferenciada)) {
      if (checkInputs.countLenth(documentoFiscal.cufeReferenciada) !== 66) {
        errors.cufeReferenciada =
          "Ingrese 66 caracteres referentes al CUFE referenciado.";
      }
    }

    if (checkInputs.notNull(documentoFiscal.nroFacturaPapel)) {
      if (checkInputs.countLenth(documentoFiscal.nroFacturaPapel) !== 22) {
        errors.nroFacturaPapel =
          "Ingrese 22 caracteres referentes al número de factura en papel.";
      }
    }

    if (checkInputs.notNull(documentoFiscal.nroFacturaImpresora)) {
      if (checkInputs.countLenth(documentoFiscal.nroFacturaImpresora) !== 22) {
        errors.nroFacturaImpresora =
          "Ingrese 22 caracteres referentes al número de factura de impresora fiscal.";
      }
    }

    //Validacion especial en caso de que el comprobante sea 04 o 05
    //Explicacion los campos B606, B616, B621 son obligatorios pero solo puede ser llenado uno
    //Ver en focha tecnica DGI apartado B604
    if (iDoc.CODIGO === "NCR" || iDoc.CODIGO === "NDR") {
      if (
        !(
          (checkInputs.notNull(documentoFiscal.cufeReferenciada) &&
            !checkInputs.notNull(documentoFiscal.nroFacturaPapel) &&
            !checkInputs.notNull(documentoFiscal.nroFacturaImpresora)) ||
          (!checkInputs.notNull(documentoFiscal.cufeReferenciada) &&
            checkInputs.notNull(documentoFiscal.nroFacturaPapel) &&
            !checkInputs.notNull(documentoFiscal.nroFacturaImpresora)) ||
          (!checkInputs.notNull(documentoFiscal.cufeReferenciada) &&
            !checkInputs.notNull(documentoFiscal.nroFacturaPapel) &&
            checkInputs.notNull(documentoFiscal.nroFacturaImpresora))
        )
      ) {
        errors.informacionReferencia =
          "Ingrese solo uno de los tres campos (CUFE, # factura papel o # factura impresa)";
      }
    }

    //Validacion especial en caso de que el comprobante sea 06 o 07
    //Explicacion los campos B606, B616, B621 son obligatorios pero solo puede ser llenado uno
    //Pero adicionalmente si los comprobantes son 06 o 07 no pueden tener el campo B606
    //Ver en focha tecnica DGI apartado B604
    if (iDoc.CODIGO === "NDG" || iDoc.CODIGO === "NCG") {
      if (
        !(
          (checkInputs.notNull(documentoFiscal.nroFacturaPapel) &&
            !checkInputs.notNull(documentoFiscal.nroFacturaImpresora)) ||
          (!checkInputs.notNull(documentoFiscal.nroFacturaPapel) &&
            checkInputs.notNull(documentoFiscal.nroFacturaImpresora))
        )
      ) {
        errors.informacionReferencia =
          "Ingrese solo uno de los dos campos (# factura papel o # factura impresa)";
      }
    }
    return errors;
  };

  return {
    setDocumentoFiscal,
    palette,
    classes,
    classesApp,
    classesGlobal,
    open,
    documentoFiscal,
    rucEmisor,
    setRucEmisor,
    isData,
    setIsData,
    cufe,
    setCufe,
    empty,
    handleClickOpen,
    handleClose,
    handleChangeUniversal,
    handleChangeRuc,
    cleanPago,
    handleAddDocumentFiscal,
    validationInputs,
  };
}

export const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 15,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);
